/* eslint-disable react-hooks/exhaustive-deps */
import camelToWords from '../../../helpers/camelToWords';
import { globalUpdatePresetOrProperty } from '../../../store/global/actions';
import Back from '../Back';
import Content from '../Content';
import editStyles from '../EditProperty/EditProperty.module.scss';
import useGetValue from '../hooks/useGetValue';
import Cube from './Cube';
import styles from './Rotation.module.scss';
import { useEffect, useMemo, useRef, useState } from 'react';
import ReactJson from 'react-json-view';
import { useDispatch } from 'react-redux';

const axis = ['x', 'y', 'z'];

const getYawAndPitch = (x, y, z) => {
  const pitch = Math.atan2(y, z);
  const yaw = -Math.asin(x);

  return [yaw, pitch];
};

const Rotation = ({ payload }) => {
  const currentValue = useGetValue(payload.id);
  const defaultValue = useGetValue(`default.${payload.id}`);
  const name = useMemo(() => camelToWords(payload.name), [payload.name]);

  const rotationRef = useRef();
  const cubeRef = useRef();
  const [key, setKey] = useState(Date.now());
  const dispatch = useDispatch();

  useEffect(() => {
    cubeRef.current = new Cube(
      rotationRef.current,
      (direction) => {
        dispatch(globalUpdatePresetOrProperty(payload.id, direction));
      },
      ...getYawAndPitch(...currentValue)
    );

    return () => {
      cubeRef.current.destroy();
    };
  }, []);

  useEffect(() => {
    cubeRef.current.setNewYawAndPitch(...getYawAndPitch(...currentValue));
  }, [key]);

  const about = useMemo(() => {
    return {
      key: payload.id,
      name: payload.name,
      type: 'Number[]',
      defaultValue,
    };
  }, [payload, defaultValue]);

  return (
    <>
      <Back title={name} index={payload.menuIndex} />

      <Content>
        <div ref={rotationRef} className={styles.rotation} />

        <div className={styles.values}>
          {currentValue.map((light, index) => (
            <div>
              <span>{axis[index]}:</span>
              {light.toFixed(5)}
            </div>
          ))}
        </div>

        <div className={styles.default}>
          <button
            onClick={() => {
              dispatch(globalUpdatePresetOrProperty(payload.id, defaultValue));

              setTimeout(() => {
                setKey(Date.now());
              }, 200);
            }}
          >
            Revert default
          </button>
        </div>

        <div className={editStyles.details}>
          <ReactJson src={about} theme="tomorrow" name="field" />
        </div>
      </Content>
    </>
  );
};

export default Rotation;
